import { Rive, RuntimeLoader } from '@rive-app/canvas';

import riveWASMResource from '@rive-app/canvas/rive.wasm?url';
RuntimeLoader.setWasmUrl(riveWASMResource);

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const STATE_MACHINES_NAME = 'ep240k';

gsap.registerPlugin(ScrollTrigger);

const setup = () => {
  const triggers = document.querySelectorAll('[data-w-dimensions]');

  triggers.forEach((trigger) => {
    gsap.to(trigger, {
      scrollTrigger: {
        trigger: trigger,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        onUpdate: (self) => {
          trigger.style.setProperty('--_progress', -0.5 + self.progress);
        },
      },
    });

    const canvasList = trigger.querySelectorAll('canvas');
    canvasList.forEach((canvas) => {
      const r = new Rive({
        src: canvas.getAttribute('data-w-rive'),
        canvas: canvas,
        autoplay: false,
        autoBind: true,
        artboard: canvas.getAttribute('data-w-artboard'),
        stateMachines: STATE_MACHINES_NAME,
        onLoad: () => {
          r.resizeDrawingSurfaceToCanvas();
          r.stopRendering();
        },
      });

      gsap.to(canvas, {
        scrollTrigger: {
          trigger: canvas,
          start: 'top center',
          end: 'bottom center',
          // fastScrollEnd: true,
          onEnter: () => {
            r.startRendering();
            r.play(STATE_MACHINES_NAME, true);
          },
          onEnterBack: () => {
            r.startRendering();
            r.play(STATE_MACHINES_NAME, true);
          },
          onLeaveBack: () => {
            r.pause(STATE_MACHINES_NAME);
            // r.reset(STATE_MACHINES_NAME);
            setTimeout(() => {
              r.stopRendering();
            }, 1);
          },
          onLeave: () => {
            r.pause(STATE_MACHINES_NAME);
            // r.reset(STATE_MACHINES_NAME);
            setTimeout(() => {
              r.stopRendering();
            }, 1);
          },
        },
      });
    });
  });
};

export default function Dimensions() {
  return {
    init: () => {
      setup();
    },
  };
}
